import {
    scrollToPreviousNextCard,
    tryRestoreLastScrollPositionAzm,
} from "@modules/tracking/previous-next-advert-cookie.ts"
import { BaseEvent } from "./BaseEvent"

/*
scrolling.js

Diese Datei ist für das Scrolling zu der richtigen Seitenposition zuständig.
 */

class ScrollingClass {
    siteScrolled: BaseEvent
    siteWasScrolledToPosition: number

    constructor() {
        this.siteScrolled = new BaseEvent(this)

        this.siteWasScrolledToPosition = 0

        $(window).on("beforeunload", () => {
            if ("scrollRestoration" in history) {
                history.scrollRestoration = "auto"
            }
        })

        //scroll to animationen stoppen wenn user scrollt.
        $("html, body").on("scroll mousedown wheel DOMMouseScroll wheel keyup touchmove", () => {
            $("html, body").stop(false, true)
        })

        // Scroll
        $(window).on(
            "scroll",
            function (this: ScrollingClass) {
                clearTimeout($.data(this, "scrollTimer"))

                $.data(
                    this,
                    "scrollTimer",
                    setTimeout(
                        function (this: ScrollingClass) {
                            this.notifySiteScrolled()
                        }.bind(this),
                        250,
                    ),
                )
            }.bind(this),
        )

        const reloadPosition = window.sessionStorage.getItem("reloadPosition")

        const prevNextId = localStorage.getItem("scrollToPreviousNextId")
        if (prevNextId) {
            localStorage.removeItem("scrollToPreviousNextId")
            scrollToPreviousNextCard(prevNextId)
            return
        }

        if (tryRestoreLastScrollPositionAzm()) {
            return
        }

        // Retrieve Scroll-Position für ein Club oder eine Location (Clustered Girls)
        if (reloadPosition === "1") {
            // fkk-club
            if ("fkkClubEinzelansicht" === SiteInfo.controller) {
                this.scrollToPosition("fkk-club")
                return
            }
            // location
            // @ts-expect-error idk where this shit can come from. TODO fix/remove
            if ("undefined" !== typeof nextPreviousConfig && nextPreviousConfig.isLocation) {
                this.scrollToPosition("location")
                return
            }

            // Keine Scrolling auf der Einzelansicht
            if (SiteInfo.controller !== "einzelansicht") {
                this.scrollToPosition(SiteInfo.controller)
            }

            try {
                window.sessionStorage.setItem("reloadPosition", "0")
            } catch (e) {
                return
            }
        }
    }

    /**
     * @private
     */
    notifySiteScrolled() {
        this.siteScrolled.notify({
            debug: "siteScrolled",
            position: $(document).scrollTop(),
        })
    }

    /**
     * Speichere die aktuelle Scroll-Position in Session-Storage
     *
     * @public
     */
    saveScrollPostion(_: string, args: { position: string }, site: string) {
        window.sessionStorage.setItem(`${site}Position`, args.position)
    }

    /**
     * Scrolle die Seite zu entsprechende Position
     *
     * @param site
     */
    scrollToPosition(site: string) {
        const position = this.getScrollPosition(site)
        const referrer = document.referrer.split("/")[2]
        const host = window.location.host
        const cameFromExternal = window.sessionStorage.getItem("externalLink") || false

        // @ts-expect-error can never happen, TODO remove?
        if (!position || position < 1) {
            return
        }

        // Wenn es ein externen Zugriff (Google, Link, usw.) ist, scrolle erst mal nicht
        if (!cameFromExternal && referrer !== host) {
            try {
                window.sessionStorage.setItem("externalLink", "true")
            } catch (e) {
                return false
            }
            return
        }

        if (position) {
            // Chrome Fix für Scroll history  scrollToPosition
            if (!this.isIOSDevice() && "scrollRestoration" in history) {
                history.scrollRestoration = "manual"
            }

            // @ts-expect-error TODO old code, idk how it can work. string/number confusion
            this.siteWasScrolledToPosition = position

            $("html,body").animate({ scrollTop: position }, 0)
        }
    }

    isIOSDevice() {
        return (
            ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
                navigator.platform,
            ) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        )
    }

    getScrollPosition(site: string) {
        const position = window.sessionStorage.getItem(`${site}Position`)
        // @ts-expect-error can never happen, TODO remove?
        if (!position || position < 1) {
            return
        }

        return position
    }
}

export const Scrolling = new ScrollingClass()
